import { ClaimsList } from "./ClaimsList";

interface ClaimsHistorySectionProps {
  contactId: string;
}

export const ClaimsHistorySection = ({ contactId }: ClaimsHistorySectionProps) => {
  return <ClaimsList contactId={contactId} />;
};